import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页 - Amiluma' }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: { title: '产品介绍 - Amiluma' }
  },
  {
    path: '/products/children',
    name: 'ProductChildren',
    component: () => import('@/views/ProductChildren.vue'),
    meta: { title: 'Lumi - Amiluma' }
  },
  {
    path: '/products/youth',
    name: 'ProductYouth',
    component: () => import('@/views/ProductYouth.vue'),
    meta: { title: 'Mellow - Amiluma' }
  },
  {
    path: '/products/elderly',
    name: 'ProductElderly',
    component: () => import('@/views/ProductElderly.vue'),
    meta: { title: 'Haven - Amiluma' }
  },
  {
    path: '/products/:productCode',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: { title: '产品详情 - Amiluma' }
  },
  {
    path: '/technology',
    name: 'Technology',
    component: () => import('@/views/Technology.vue'),
    meta: { title: '技术引擎 - Amiluma' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于我们 - Amiluma' }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: { title: '新闻动态 - Amiluma' }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue'),
    meta: { title: '新闻详情 - Amiluma' }
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import('@/views/Cooperation.vue'),
    meta: { title: '商务合作 - Amiluma' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

export function resolvePageTitle(metaTitle) {
  return metaTitle || 'Amiluma'
}

router.afterEach((to) => {
  document.title = resolvePageTitle(to.meta && to.meta.title)
})

export default router
